import React from 'react'

import { string, bool, func, array } from 'prop-types'
import { SVGIcon } from 'components/qstrap'
import Typography from 'components/atoms/Typography'
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'
import classNames from 'classnames'

const MajorAccordion = ({ major, programs, active, onClick }) => (
  <div className={classNames('major-accordion', { active })} onClick={onClick}>
    <div className="major-accordion__major">
      <Typography component="p" variant="body" className="major-accordion__major-text font-bolder">{major}</Typography>
      <SVGIcon name="common-next" size="md" className="major-accordion__arrow" />
    </div>
    <CSSTransitionGroup
      transitionName="program"
      transitionEnterTimeout={500}
      transitionLeaveTimeout={500}
    >
      {
        active && (
          <div className="major-accordion__program">
            {
              programs.map(item =>
                <Typography variant="subbody" component="p" className="major-accordion__item">{item}</Typography>
              )
            }
          </div>
        )
      }
    </CSSTransitionGroup>
    <style jsx>
      {`
        .major-accordion{
          :global(&__major) {
            display: flex;
            cursor: pointer;
            padding: 16px;
            background-image: linear-gradient(112deg, #00beff, #0fc3c4);
            border-radius: 8px;
            margin: 8px 8px 0 8px;
            height: 56px;
            display: flex;
            align-items: center;
            min-width: 280px;
            color: #fff;
            transition: .4s ease-in-out;
          }
          :global(&__arrow) {
            transition: .4s ease-in-out;
          }
          :global(&__major-text) {
            display: inline;
            flex-grow: 1;
            color: #fff !important;
            margin-left: 8px !important;
          }
          &__program {
            padding: 16px;
            margin: 0 8px 8px 8px;
            border-bottom-left-radius: 8px;
            border-bottom-right-radius: 8px;
            box-shadow: 0 2px 8px 0 #ebeef3;
            border: solid 1px #d3dce6;
            background-color: #ffffff;
          }
          :global(&__item) {
            display: list-item;
            margin-left: 20px !important;
            color: #1e3f6b !important;
          }
          &.active {
            :global(.major-accordion__major) {
              border-top-left-radius: 8px;
              border-top-right-radius: 8px;
              border-bottom-left-radius: 0px;
              border-bottom-right-radius: 0px;
            }
            :global(.major-accordion__arrow) {
              transform: rotate(90deg);
            }
          }

          @media screen and (max-width: 767px) {
            :global(&__major){
              width: 100%;
            }
            &__program {
              width: 100%;
            }
          }
        }
        .program-enter {
          max-height: 0px;
          transition: all .5s ease-in-out;
          overflow: hidden;
        }
        .program-enter-active {
          height: auto;
          max-height: 256px;
        }
        .program-leave {
          height: auto;
          max-height: 256px;
        }
        .program-leave-active {
          overflow: hidden;
          max-height: 0px;
          transition: all .5s ease-in-out;
        }
      `}
    </style>
  </div>
)

MajorAccordion.propTypes = {
  major: string,
  programs: array,
  active: bool,
  onClick: func,
}

export default MajorAccordion
